import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { LookInside } from './components/LookInside';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen w-full bg-plum text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="23t8ea5wf0398">
      <MetaPixel data-id="element-1" data-mp="3mljaezbgzl56" />
      <main data-id="element-2" data-mp="3ml13n8r6loj0">
        <Hero data-id="element-3" data-mp="3mkrgdsxitvh0" />
        <SocialProofBar data-id="element-4" data-mp="3mk85gw6ag7ch" />
        <Testimonials data-id="element-5" data-mp="3mjgannkimdn9" />
        <PainGrid data-id="element-6" data-mp="3rc9co3oln7vn" />
        <ProductReveal data-id="element-7" data-mp="3rbrcivytg9ig" />
        <Tomes data-id="element-8" data-mp="3rdkgg3i1ofmr" />
        <Bonuses data-id="element-9" data-mp="3rd1all5o5hp3" />
        <LookInside data-id="element-10" data-mp="3relumgucxi8p" />
        <ValueStack data-id="element-11" data-mp="5orh0l86u6j" />
        <Urgency data-id="element-12" data-mp="682dxcgkib2" />
        <Pricing data-id="element-13" data-mp="4n7g6m8exco" />
        <Guarantee data-id="element-14" data-mp="56qjqnmbrsa" />
        <Faq data-id="element-15" data-mp="2zl39tfhhuw2o" />
        <CostOfInaction data-id="element-16" data-mp="2zld259q0hfbj" />
        <Close data-id="element-17" data-mp="2zm4zaoz9bl3x" />
      </main>
      <Footer data-id="element-18" data-mp="2zmwit1fkxsdu" />
      <PurchaseNotifications data-id="element-19" data-mp="2zng1ikd20ksx" />
    </div>;
}